module.exports = __webpack_public_path__ + "static/img/case-mobile-diagram-03.1fdca3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-mobile-diagram-03.png
// module id = f3+W
// module chunks = 1